import { rem } from 'polished'
import styled from 'styled-components'

export const ImporterStepIndicatorStyled = styled.div`
  font-size: ${rem(16)};

  display: grid;
  grid-area: step-indicator;

  justify-items: center;

  padding-bottom: ${rem(16)};
`
